import { createSlice } from '@reduxjs/toolkit';
import { getWithdrawalById, getWithdrawalsList, updateWithdrawalStatus } from './withdrawalsService';

const initialState = {
    withdrawalsList: {
        isWithdrawalsLoading: null,
        isWithdrawalsSuccess: null,
        pageCount: 0,
        withdrawals: [],
    },
    updateWithdrawalStatus: {
        isWithdrawalChanging: null,
        isStatusSuccess: null,
        withdrawalDetails: [],
    },
    withdrawDetails: {
        isWithdrawLoading: null,
        isWithdrawLoaded: null,
        withdrawRequestDetails: null,
    }
};

const withdrawalsSlice = createSlice({
    name: 'withdrawal',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWithdrawalsList.pending, (state) => {
            state.withdrawalsList = {
                ...initialState.withdrawalsList,
                isWithdrawalsLoading: true,
            };
        });

        builder.addCase(getWithdrawalsList.rejected, (state) => {
            state.withdrawalsList = {
                ...initialState.withdrawalsList,
                isWithdrawalsLoading: false,
                isWithdrawalsSuccess: false,
            };
        });

        builder.addCase(getWithdrawalsList.fulfilled, (state, action) => {
            state.withdrawalsList = {
                ...initialState.withdrawalsList,
                isWithdrawalsLoading: false,
                isWithdrawalsSuccess: true,
                pageCount: action.payload.pageCount || 0,
                withdrawals: action.payload.data || [],
            };
        });

        //Withdrawal publish
        builder.addCase(updateWithdrawalStatus.pending, (state) => {
            state.updateWithdrawalStatus = {
                ...initialState.updateWithdrawalStatus,
                isWithdrawalChanging: true,
            };
        });

        builder.addCase(updateWithdrawalStatus.rejected, (state) => {
            state.updateWithdrawalStatus = {
                ...initialState.updateWithdrawalStatus,
                isWithdrawalChanging: false,
                isStatusSuccess: false,
            };
        });

        builder.addCase(updateWithdrawalStatus.fulfilled, (state, action) => {
            state.updateWithdrawalStatus = {
                ...initialState.updateWithdrawalStatus,
                isWithdrawalChanging: false,
                isStatusSuccess: true,
                withdrawalDetails: action.payload.data || [],
            };
        });

        //Withdraw details
        builder.addCase(getWithdrawalById.pending, (state) => {
            state.withdrawDetails = {
                ...initialState.withdrawDetails,
                isWithdrawLoading: true,
            };
        });

        builder.addCase(getWithdrawalById.rejected, (state) => {
            state.withdrawDetails = {
                ...initialState.withdrawDetails,
                isWithdrawLoading: false,
                isWithdrawLoaded: false,
            };
        });

        builder.addCase(getWithdrawalById.fulfilled, (state, action) => {
            state.withdrawDetails = {
                ...initialState.withdrawDetails,
                isWithdrawLoading: false,
                isWithdrawLoaded: true,
                withdrawRequestDetails: action.payload || [],
            };
        });
    },
});

export default withdrawalsSlice.reducer;
